import { initBillingCopyFromRegistration } from '../share/billing-copy-from-registration';

document.addEventListener('DOMContentLoaded', () => {
    initBillingCopyFromRegistration();
});
